// Simple property search functionality for landlord property ownerships
function initPropertySearch() {
  // Find all search containers on the page
  const searchContainers = document.querySelectorAll('[data-search-container]');

  searchContainers.forEach(container => {
    const index = container.getAttribute('data-search-container');
    const searchInput = container.querySelector(`[data-search-input="${index}"]`);
    const resultsContainer = container.querySelector(`[data-search-results="${index}"]`);
    const hiddenField = document.querySelector(`[data-property-id="${index}"]`);

    if (!searchInput || !resultsContainer || !hiddenField) return;

    let searchTimeout;

    // Handle search input
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const query = this.value.trim();

      if (query.length < 2) {
        resultsContainer.classList.add('hidden');
        resultsContainer.innerHTML = '';
        return;
      }

      // Debounce search requests
      searchTimeout = setTimeout(() => {
        performSearch(query, searchInput, resultsContainer, hiddenField);
      }, 300);
    });

    // Hide results when clicking outside
    document.addEventListener('click', function(event) {
      if (!container.contains(event.target)) {
        resultsContainer.classList.add('hidden');
      }
    });
  });
}

function performSearch(query, searchInput, resultsContainer, hiddenField) {
  const landlordId = searchInput.getAttribute('data-landlord-id');
  const url = `/landlords/${landlordId}/search_properties?q=${encodeURIComponent(query)}`;

  fetch(url, {
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(properties => {
    displaySearchResults(properties, resultsContainer, searchInput, hiddenField);
  })
  .catch(error => {
    console.error('Property search error:', error);
    resultsContainer.innerHTML = '<div class="p-3 text-sm text-red-600">Search failed. Please try again.</div>';
    resultsContainer.classList.remove('hidden');
  });
}

function displaySearchResults(properties, resultsContainer, searchInput, hiddenField) {
  if (properties.length === 0) {
    resultsContainer.innerHTML = '<div class="p-3 text-sm text-gray-500 dark:text-gray-400">No properties found</div>';
  } else {
    const resultHTML = properties.map(property => `
      <div class="p-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-200 dark:border-gray-600 last:border-b-0"
           data-property-id="${property.id}"
           data-property-text="${property.text}"
           data-property-address="${property.address || ''}">
        <div class="text-sm font-medium text-gray-900 dark:text-white">${property.text}</div>
        ${property.address ? `<div class="text-xs text-gray-500 dark:text-gray-400">${property.address}</div>` : ''}
      </div>
    `).join('');

    resultsContainer.innerHTML = resultHTML;

    // Add click handlers for each result
    resultsContainer.querySelectorAll('[data-property-id]').forEach(item => {
      item.addEventListener('click', function() {
        const propertyId = this.getAttribute('data-property-id');
        const propertyText = this.getAttribute('data-property-text');

        // Update the hidden field and search input
        hiddenField.value = propertyId;
        searchInput.value = propertyText;

        // Show the remove button for new property ownerships
        showRemoveButtonForNewOwnership(searchInput);

        // Hide results
        resultsContainer.classList.add('hidden');
      });
    });
  }

  resultsContainer.classList.remove('hidden');
}

// Show remove button when a property is selected in new ownership forms
function showRemoveButtonForNewOwnership(searchInput) {
  const ownershipDiv = searchInput.closest('.new-property-ownership');
  if (ownershipDiv) {
    const removeButtonContainer = ownershipDiv.querySelector('.remove-button-container');
    if (removeButtonContainer) {
      removeButtonContainer.classList.remove('hidden');
      removeButtonContainer.style.display = 'block';
    }
  }
}

// Hide remove button when property is cleared
function hideRemoveButtonForNewOwnership(ownershipDiv) {
  const removeButtonContainer = ownershipDiv.querySelector('.remove-button-container');
  if (removeButtonContainer) {
    removeButtonContainer.classList.add('hidden');
    removeButtonContainer.style.display = 'none';
  }
}

// Initialize on page load and Turbo navigation
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPropertySearch);
} else {
  initPropertySearch();
}

document.addEventListener('turbo:load', initPropertySearch);

// Property ownership management functions
window.addPropertyOwnership = function() {
  const container = document.getElementById('new-property-ownerships');

  if (!container) {
    return;
  }

  const uniqueId = Date.now() + Math.random();
  const landlordId = window.location.pathname.split('/')[2]; // Extract landlord ID from URL

  // Create new property ownership form HTML
  const newOwnershipHTML = `
    <div class="bg-gray-50 dark:bg-gray-900 rounded-lg p-4 border border-gray-200 dark:border-gray-700 new-property-ownership mb-4">
      <!-- Property Selection -->
      <div class="mb-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">Property *</label>

          <!-- Search field for new ownerships -->
          <div class="relative" data-search-container="${uniqueId}">
            <input type="text"
                   placeholder="Type to search for property..."
                   class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                   data-search-input="${uniqueId}"
                   data-landlord-id="${landlordId}">

            <!-- Search Results -->
            <div class="search-results absolute z-10 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-48 overflow-y-auto hidden"
                 data-search-results="${uniqueId}">
            </div>
          </div>
          <input type="hidden" name="landlord[property_ownerships_attributes][][property_id]" data-property-id="${uniqueId}" value="">
        </div>

        <!-- Hidden ownership percentage field - defaults to 100% -->
        <input type="hidden" name="landlord[property_ownerships_attributes][][ownership_percentage]" value="100.0">
      </div>

      <!-- Optional Date Fields -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">Start Date</label>
          <input type="date"
                 name="landlord[property_ownerships_attributes][][start_date]"
                 class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800">
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">End Date</label>
          <input type="date"
                 name="landlord[property_ownerships_attributes][][end_date]"
                 class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800">
        </div>
      </div>

      <!-- Notes Field -->
      <div class="mb-4">
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">Notes</label>
        <textarea name="landlord[property_ownerships_attributes][][notes]"
                  placeholder="Additional notes about this ownership..."
                  rows="2"
                  class="w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"></textarea>
      </div>

      <!-- Remove Button (initially hidden, shown when property is selected) -->
      <div class="remove-button-container hidden" style="display: none;">
        <div class="flex justify-end">
          <button type="button" onclick="removeNewPropertyOwnership(this)" class="px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-300 rounded-lg hover:bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-600 dark:hover:bg-red-900/20 cursor-pointer flex items-center">
            Remove This Property
          </button>
        </div>
      </div>
    </div>
  `;

  // Insert the new form into the container
  container.insertAdjacentHTML('beforeend', newOwnershipHTML);

  // Find the search container we just created and initialize search functionality
  const searchContainer = container.querySelector(`[data-search-container="${uniqueId}"]`);
  initPropertySearchForContainer(searchContainer);
};

window.removePropertyOwnership = function(ownershipId, button) {
  // For existing (persisted) property ownerships, make AJAX DELETE request
  if (!confirm('Are you sure you want to remove this property ownership?')) {
    return;
  }

  const ownershipDiv = button.closest('.bg-gray-50, .bg-gray-900');
  const landlordId = window.location.pathname.split('/')[2]; // Extract landlord ID from URL

  // Disable button to prevent double-clicks
  button.disabled = true;
  button.textContent = 'Removing...';

  fetch(`/landlords/${landlordId}/property_ownerships/${ownershipId}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Remove the entire ownership section from DOM
      ownershipDiv.remove();
    } else {
      throw new Error(data.message || 'Failed to remove property ownership');
    }
  })
  .catch(error => {
    console.error('Error removing property ownership:', error);
    alert('Error removing property ownership: ' + error.message);

    // Re-enable button on error
    button.disabled = false;
    button.textContent = 'Remove This Property';
  });
};

window.removeNewPropertyOwnership = function(button) {
  // For new property ownerships, just remove from DOM
  const ownershipDiv = button.closest('.new-property-ownership');
  ownershipDiv.remove();
};

// Helper function to initialize search for a specific container
function initPropertySearchForContainer(container) {
  if (!container) return;

  const uniqueId = container.getAttribute('data-search-container');
  const searchInput = container.querySelector(`[data-search-input="${uniqueId}"]`);
  const resultsContainer = container.querySelector(`[data-search-results="${uniqueId}"]`);
  const hiddenField = document.querySelector(`[data-property-id="${uniqueId}"]`);

  if (!searchInput || !resultsContainer || !hiddenField) return;

  let searchTimeout;

  // Remove any existing event listeners
  searchInput.removeEventListener('input', searchInput._propertySearchHandler);

  // Handle search input
  searchInput._propertySearchHandler = function() {
    clearTimeout(searchTimeout);
    const query = this.value.trim();

    if (query.length < 2) {
      resultsContainer.classList.add('hidden');
      resultsContainer.innerHTML = '';

      // If input is cleared and this is a new ownership, hide remove button and clear hidden field
      const ownershipDiv = this.closest('.new-property-ownership');
      if (ownershipDiv && this.value.trim() === '') {
        hideRemoveButtonForNewOwnership(ownershipDiv);
        hiddenField.value = '';
      }
      return;
    }

    // Debounce search requests
    searchTimeout = setTimeout(() => {
      performSearch(query, searchInput, resultsContainer, hiddenField);
    }, 300);
  };

  searchInput.addEventListener('input', searchInput._propertySearchHandler);

  // Hide results when clicking outside
  document.addEventListener('click', function(event) {
    if (!container.contains(event.target)) {
      resultsContainer.classList.add('hidden');
    }
  });
}

export default initPropertySearch;